export default __webpack_public_path__ + "static/media/monCompte.2ae67df0.svg";